

















































































































































































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import PicModal from '@/components/upload/picModal.vue'
// import SelectUrl from '@/components/selectUrl/index.vue'
import SelectUrl from '../../floorSet/components/selectUrl.vue'
@Component({
  components: {
    PicModal,
    SelectUrl,
  },
})
export default class Pictures extends Vue {
  @Prop({
    type: Boolean,
    default: () => false,
  })
  showDemo!: boolean

  @Prop({
    type: Object,
    default: () => {
      return {
        type: 'pictures',
        styleType: 0,
        name: '多图组件',
        displayOrder: '',
        isActive: true,
        backgroundType: 0,
        backgroundUrl: null,
        isDisplayName: false,
        // 0多图组件/1商品列表/2营销活动
        componentType: 0,
        // 图片组件数据
        photosComponent: {
          // 0表示图片 1表示轮播
          displayType: 0,
          displayMode: 0,
          photoItems: [
            {
              displayOrder: 0,
              linkUrl: null,
              photoUrl: null,
            },
          ],
        },
        // 商品组件数据
        productsComponent: {
          productItems: [],
        },
        // 活动组件
        activitiesComponent: {
          activityItems: [],
        },
      }
    },
  })
  PicturesConfig!: any

  //选择的图片下标
  selectIndex = 0

  styleList = [
    {
      img: require('@/assets/images/shopMall/pc/pic/1.jpg'),
      title: '一行一个',
      num: 1,
      type: 0,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/2.jpg'),
      title: '一行两个',
      num: 2,
      type: 1,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/3.jpg'),
      title: '一行三个',
      num: 3,
      type: 2,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/4.jpg'),
      title: '一行四个',
      num: 4,
      type: 3,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/6.jpg'),
      title: '一行五个',
      num: 5,
      type: 5,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/5.jpg'),
      title: '两左两右',
      num: 4,
      type: 4,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/7.jpg'),
      title: '一左四右',
      num: 5,
      type: 6,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/8.jpg'),
      title: '左二右一',
      num: 3,
      type: 7,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/9.jpg'),
      title: '左一右二',
      num: 3,
      type: 8,
    },
    {
      img: require('@/assets/images/shopMall/pc/pic/10.jpg'),
      title: '左四右一',
      num: 5,
      type: 9,
    },
  ]

  get imgObj() {
    return this.PicturesConfig.photosComponent.photoItems[this.selectIndex]
  }

  mounted() {}

  /**
   * 样式更改
   */
  styleChange(row, index) {
    this.PicturesConfig.styleType = index
    this.PicturesConfig.photosComponent.displayMode = index
    if (this.PicturesConfig.photosComponent.photoItems.length < row.num) {
      let len = row.num - this.PicturesConfig.photosComponent.photoItems.length
      for (let i = 0; i < len; i++) {
        let obj = {
          photoUrl: null,
          linkUrl: null,
        }
        this.PicturesConfig.photosComponent.photoItems.push(obj)
      }
    } else if (this.PicturesConfig.photosComponent.photoItems.length > row.num) {
      let len = this.PicturesConfig.photosComponent.photoItems.length - row.num
      this.PicturesConfig.photosComponent.photoItems.splice(row.num, len)
    }
    this.selectIndex = 0
  }

  /**
   * 选择图片
   */
  picChange(e) {
    this.PicturesConfig.photosComponent.photoItems[this.selectIndex]['photoUrl'] = e[0].url
  }

  urlChange(e) {
    this.imgObj.linkUrl = e
  }

  /**
   * 选择虚线框
   */
  selectChange(index) {
    this.selectIndex = index
  }

  /**
   * 删除图片
   */
  deleteFn(index) {
    this.PicturesConfig.photosComponent.photoItems.splice(index, 1)
  }

  /**
   * 添加图片
   */
  addFn() {
    let obj = {
      displayOrder: 0,
      photoUrl: null,
      linkUrl: null,
    }
    this.PicturesConfig.photosComponent.photoItems.push(obj)
  }
}
